export default __webpack_public_path__ + "static/media/Chants.5e3a62e9.svg";